import { ColumnInstance, SortingRule } from 'react-table';

export const getSortByString = (sortByRule: SortingRule<any>) => {
  return `${sortByRule.id},${sortByRule.desc ? 'desc' : 'asc'}`;
};

export const getSortByRule = (sort: string) => {
  const [id, desc] = sort.split(',');

  return {
    id,
    desc: desc === 'desc',
  };
};

export const defaultPropGetter = () => ({});

export const defaultIsRowSelectable = () => true;

export const getAriaSortString = (column: ColumnInstance<any>) => {
  if (!column.canSort) {
    return undefined;
  }

  if (column.isSorted) {
    return column.isSortedDesc ? 'descending' : 'ascending';
  }

  return 'none';
};
